var _excluded = ["children", "defaultSelectedKey", "selectedKey", "tooltip", "onChange", "onOpenChange", "onScroll", "onSelectionChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { EMPTY_FUNCTION, ensureArray } from '@deephaven/utils';
import { useMemo } from 'react';
import { PICKER_TOP_OFFSET } from "../../UIConstants.js";
import { normalizeTooltipOptions, wrapItemChildren, useOnChangeTrackUncontrolled, useStaticItemInitialScrollPosition } from "../utils/index.js";
import usePickerItemScale from "./usePickerItemScale.js";
import usePickerScrollOnOpen from "./usePickerScrollOnOpen.js";
/** Props that are derived by `usePickerProps`. */
/** 
 * Props that are passed through untouched. (should exclude all of the
 * destructured props passed into `usePickerProps` that are not in the spread
 * ...props)
) */
/** Props returned from `usePickerProps` hook. */
/**
 * Derive props for Picker components (e.g. Picker and ComboBox). Specifically
 * handles wrapping children items and initial scroll position when the picker
 * is opened.
 */
export function usePickerProps(_ref) {
  var children = _ref.children,
    defaultSelectedKey = _ref.defaultSelectedKey,
    selectedKey = _ref.selectedKey,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? true : _ref$tooltip,
    onChangeHandler = _ref.onChange,
    onOpenChangeHandler = _ref.onOpenChange,
    _ref$onScroll = _ref.onScroll,
    onScroll = _ref$onScroll === void 0 ? EMPTY_FUNCTION : _ref$onScroll,
    onSelectionChangeHandler = _ref.onSelectionChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _usePickerItemScale = usePickerItemScale(),
    itemHeight = _usePickerItemScale.itemHeight;
  var tooltipOptions = useMemo(() => normalizeTooltipOptions(tooltip), [tooltip]);
  var items = useMemo(() => ensureArray(wrapItemChildren(children !== null && children !== void 0 ? children : [], tooltipOptions)), [children, tooltipOptions]);
  var _useOnChangeTrackUnco = useOnChangeTrackUncontrolled({
      defaultSelectedKey,
      selectedKey,
      onChange: onChangeHandler !== null && onChangeHandler !== void 0 ? onChangeHandler : onSelectionChangeHandler
    }),
    selectedKeyMaybeUncontrolled = _useOnChangeTrackUnco.selectedKeyMaybeUncontrolled,
    onChangeMaybeUncontrolled = _useOnChangeTrackUnco.onChangeMaybeUncontrolled;
  var getInitialScrollPosition = useStaticItemInitialScrollPosition({
    itemHeight,
    items,
    selectedKey: selectedKeyMaybeUncontrolled,
    topOffset: PICKER_TOP_OFFSET
  });
  var _usePickerScrollOnOpe = usePickerScrollOnOpen({
      getInitialScrollPosition,
      onScroll,
      onOpenChange: onOpenChangeHandler
    }),
    ref = _usePickerScrollOnOpe.ref,
    onOpenChange = _usePickerScrollOnOpe.onOpenChange;
  return _objectSpread(_objectSpread({}, props), {}, {
    defaultSelectedKey,
    ref,
    selectedKey,
    children: items,
    onOpenChange,
    onSelectionChange: onChangeMaybeUncontrolled
  });
}
export default usePickerProps;
//# sourceMappingURL=usePickerProps.js.map